/**
 * PEARSON PROPRIETARY AND CONFIDENTIAL INFORMATION SUBJECT TO NDA
 * Copyright © 2017 Pearson Education, Inc.
 * All Rights Reserved.
 *
 * NOTICE:  All information contained herein is, and remains
 * the property of Pearson Education, Inc.  The intellectual and technical concepts contained
 * herein are proprietary to Pearson Education, Inc. and may be covered by U.S. and Foreign Patents,
 * patent applications, and are protected by trade secret or copyright law.
 * Dissemination of this information, reproduction of this material, and copying or distribution of this software
 * is strictly forbidden unless prior written permission is obtained
 * from Pearson Education, Inc.
 * */
import React from 'react';
import SvgIcon from '@material-ui/core/SvgIcon';

/**
 * A React component for audio off icon.
 *
 * @author Hari Gangadharan
 */
const AudioOff = props => (
  <SvgIcon viewBox="0 0 18 18" {...props}>
    <path
      d="M14.707 8l2.146-2.147a.5.5 0 1 0-.707-.708L14 7.292l-2.147-2.147a.5.5 0 0
      0-.707.708L13.293 8l-2.147 2.146A.502.502 0 0 0 11.5 11a.498.498 0 0 0
      .353-.146L14 8.706l2.146 2.147a.502.502 0 0 0 .707 0 .5.5 0 0 0 0-.708L14.707
      8zM9.696.04a.503.503 0 0 0-.542.098L4.061 5H1.727C.775 5 0 5.784 0 6.75v2.5C0
      10.214.775 11 1.727 11h2.334l5.093 4.861a.503.503 0 0 0 .542.1.5.5 0 0 0
      .304-.46V.5a.5.5 0 0 0-.304-.46"
    />
  </SvgIcon>
);

export default AudioOff;



// WEBPACK FOOTER //
// ./src/js/icons/AudioOff.jsx